var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "base-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.baseDialogOpen,
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.baseDialogOpen = $event
            },
          },
        },
        [_vm.contentDialog.addNote ? _c("AddNote") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }